import { render, staticRenderFns } from "./peopleSelect.vue?vue&type=template&id=846aa760&scoped=true&"
import script from "./peopleSelect.vue?vue&type=script&lang=js&"
export * from "./peopleSelect.vue?vue&type=script&lang=js&"
import style0 from "./peopleSelect.vue?vue&type=style&index=0&id=846aa760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846aa760",
  null
  
)

export default component.exports